/* istanbul ignore file */
import React from 'react';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { WysiwygInputPasteArtifactDecorator } from 'domain/shared/artifact/input';
import { WysiwygInput, WysiwygInputProps } from 'framework/form';

interface ResumeWysiwygInputProps extends WysiwygInputProps {
  artifactsSource: string;
}

const ResumeWysiwygInput = ({ artifactsSource, ...props }: ResumeWysiwygInputProps) => {
  return (
    <WysiwygInputPasteArtifactDecorator artifactsSource={artifactsSource} artifactTypeId={ARTIFACT_ID.CANDIDATE_RESUME}>
      <WysiwygInput height={100} {...props} />
    </WysiwygInputPasteArtifactDecorator>
  );
};

export default ResumeWysiwygInput;
